import { Translations } from "@/translations/strings"
import { ClinicConfigStoryblok, ConfigStoryblok } from "@/types/component-types"
import { create } from "zustand"

export type MergedClinicConfig = ClinicConfigStoryblok & Pick<ConfigStoryblok, "app_store_link" | "google_play_link">

export type ConfigStoreProps = {
  config: ConfigStoryblok | MergedClinicConfig | null | undefined
  strings: Translations | null
  en: boolean
  enabledRegions?: string[]
}

export const useConfigStore = create<ConfigStoreProps>(() => ({
  config: null,
  strings: null,
  en: false,
  enabledRegions: []
}))
